/**
 * Plan Lock Slice
 * Drives the global plan-restriction lock dialog (see PlanLockDialog.tsx).
 * Triggered either instantly client-side (usePlanGate) or reactively from a
 * backend FORBIDDEN/QUOTA_EXCEEDED response (plan-lock.util.ts).
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PlanLockPayload {
  title: string;
  message: string;
  /** 'wallet' = prepaid-wallet block: the CTA tops up instead of upgrading. */
  kind?: 'plan' | 'wallet';
}

export interface PlanLockState {
  open: boolean;
  payload: PlanLockPayload | null;
}

const initialState: PlanLockState = {
  open: false,
  payload: null,
};

const planLockSlice = createSlice({
  name: 'planLock',
  initialState,
  reducers: {
    showPlanLock: (state, action: PayloadAction<PlanLockPayload>) => {
      state.open = true;
      state.payload = action.payload;
    },
    hidePlanLock: (state) => {
      state.open = false;
    },
  },
});

export const { showPlanLock, hidePlanLock } = planLockSlice.actions;
export default planLockSlice.reducer;
